module.exports = __webpack_public_path__ + "static/img/daizhifu@2x.5b90141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daizhifu@2x.png
// module id = 2pny
// module chunks = 1